<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div>
    <ik-data-table
      ref="brandingPlan"
      :model="model"
      entity-name="活动计划"
    />
  </div>
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import BrandingPlan from '@/model/dataLayer/api/branding/BrandingPlan'

export default {
  components: { IkDataTable },
  data: function () {
    return ({
      model: BrandingPlan
    })
  }
}
</script>
